import ttt from '@xing-com/ticktricktrack';

export type TrackActionSheetOpenType = (props: {
  inputHintClick: boolean;
  propChannel: string;
  propSocialInteractionId: string;
  interactionTargetUrn: string;
}) => void;

export const trackActionSheetOpen: TrackActionSheetOpenType = ({
  inputHintClick,
  propChannel,
  propSocialInteractionId,
  interactionTargetUrn,
}) => {
  ttt.event('PropTrackAction', {
    PropTrackAction: 'social_interaction_sheet_open',
    PropSocialObjectId: interactionTargetUrn,
    PropSocialInteractionId: propSocialInteractionId,
    PropChannel: propChannel,
    ...(inputHintClick && {
      PropContextDimension3: 'social_overview_comment_click',
    }),
  });
};
